import Shuffler from './shuffler';

export function init(tilesElm){
    const shuffler = new Shuffler({
        element: tilesElm,
        selectors: {
            filterBtn: '.js-c-tiles-filter-btn',
            filterTaskBtn: '.js-c-tiles-filter-task-btn',
            search: '.js-c-tiles-search',
            counter: '.js-c-tiles-counter'
        }
    });

    shuffler.init();

    return shuffler;
}

export default {
    init
};


